<script setup>
const { loggedIn, user } = useAuth()
const profile = useProfileStore()

// Only show call console if user is logged in AND has phone number
const shouldShowCallConsole = computed(() => {
  return loggedIn.value && user.value && profile.hasPhoneNumber
})
</script>

<template>
  <div class="bg-gray-100">
    <!-- <Navigation /> -->
    <navigation />
    <main>
      <slot />
      <call-console v-if="shouldShowCallConsole" />
    </main>
  </div>
</template>

<style>
html {
  background-color: rgba(243 244 246 / 100%);
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  appearance: none;
  margin: 0;
}

/* Firefox */
input[type='number'] {
  appearance: textfield;
}
</style>
